export default "__VITE_ASSET__23dc2bed__"